import styled from 'styled-components';
import { Button, token } from '@bynder/design-system';
import { VISUALS, device } from '../../../constants/styles';

export const StyledButton = styled(Button)`
  &:hover {
    background-color: inherit;
    color: ${props => props.theme.primaryColor};
  }
`;

export const StyledNavigation = styled.nav<{
  $isCollapsed: boolean;
}>`
  ${({ theme, $isCollapsed }) => {
    const { getValueOrDefault } = theme;

    return `
      position: relative;
      width: ${$isCollapsed && '0px'};
      z-index: 15;
      background-color: ${getValueOrDefault('sideBar.backgroundColor.hexCode')};
      flex: 0 0 auto;
      border-right: 1px solid ${getValueOrDefault(
        'sideBar.borderColor.hexCode',
      )};
      height: calc(100vh - ${VISUALS.HEADER_HEIGHT});
      overflow-x: hidden;
      overflow-y: auto;
      ::-webkit-scrollbar {
        display: none;
      }

      left: ${$isCollapsed ? `calc(${VISUALS.SIDEBAR_WIDTH} * -1)` : '0px'};
      transition: 0.5s;
      ul {
        font-size: 1em;
      }
    `;
  }}
`;

export const StyledButtonContainer = styled.div<{ $isCollapsed: boolean }>`
  width: 80px;
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 12px;
  top: calc(${VISUALS.HEADER_HEIGHT} + ${token.spacing5});
  left: ${props => (!props.$isCollapsed ? VISUALS.SIDEBAR_WIDTH : '0px')};
  padding-left: ${token.spacing5};
  transition: 0.5s;
  z-index: 300;
`;

export const StyledNavigationList = styled.div<{
  $isCollapsed: boolean;
}>`
  overflow: hidden;
  background-color: ${({ theme }) =>
    theme.getValueOrDefault('sideBar.backgroundColor.hexCode')};
  @media ${device.mobile} {
    width: 99vw;
  }

  @media ${device.tablet} {
    width: ${VISUALS.SIDEBAR_WIDTH};
  }
`;
